import { createSlice } from "@reduxjs/toolkit";
import {
  addProjectDetails,
  fetchMyProjects,
  fetchProjectDeliveableHireDetails,
  fetchProjectDetails,
  fetchRecommendedFreelancer,
  fetchRecommendedHireTalentMactching,
  markAsComplete,
  sendInvitationToFreelancer,
  uploadDeliveableProject,
} from "../actions/projectAction";

const initialState = {
  isLoading: false,
  isViewProjectDetails: false,
  isInvite: false,
  projectList: {},
  projectData: {},
  recomFreelancerList: [],
  deliveableList: []
};

const projectSlice = createSlice({
  name: "hire-talent-projects",
  initialState,
  reducers: {
    setIsViewProjectDetails: (state, action) => {
      state.isViewProjectDetails = action.payload;
    },
    setIsInvite: (state, action) => {
      state.isInvite = action.payload;
    },
  },
  extraReducers: (builder) => {
    // fetch-my-projects
    builder.addCase(fetchMyProjects.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchMyProjects.fulfilled, (state, action) => {
      const { data } = action.payload || {};

      state.isLoading = false;
      const grouped = Object?.groupBy(data?.projects || [], (p) => p?.status);
      state.projectList = {
        all: data?.projects || [],
        ...grouped,
      };
    });
    builder.addCase(fetchMyProjects.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-project-details
    builder.addCase(fetchProjectDetails.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchProjectDetails.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.projectData = data || {};
      state.isViewProjectDetails = true;
      state.isLoading = false;
    });
    builder.addCase(fetchProjectDetails.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetchProjectDeliveableHireDetails
    builder.addCase(fetchProjectDeliveableHireDetails.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchProjectDeliveableHireDetails.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.deliveableList = data?.deliverables || [];
      state.isLoading = false;
    });
    builder.addCase(fetchProjectDeliveableHireDetails.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-recommended-freelancer
    builder.addCase(fetchRecommendedFreelancer.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchRecommendedFreelancer.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.recomFreelancerList = data?.talents || [];
      state.isLoading = false;
    });
    builder.addCase(fetchRecommendedFreelancer.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addProjectDetails.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(addProjectDetails.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addProjectDetails.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-recommended-freelancer
    builder.addCase(sendInvitationToFreelancer.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(sendInvitationToFreelancer.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isInvite = false;
    });
    builder.addCase(sendInvitationToFreelancer.rejected, (state, action) => {
      state.isLoading = false;
    });
    // mark-as-completed
    builder.addCase(markAsComplete.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(markAsComplete.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(markAsComplete.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetchRecommendedHireTalentMactching
    builder.addCase(fetchRecommendedHireTalentMactching.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchRecommendedHireTalentMactching.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.recomFreelancerList = data?.talents || [];
      state.isLoading = false;
    });
    builder.addCase(fetchRecommendedHireTalentMactching.rejected, (state, action) => {
      state.isLoading = false;
    });

    // uploadDeliveableProject
    builder.addCase(uploadDeliveableProject.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(uploadDeliveableProject.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(uploadDeliveableProject.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export default projectSlice.reducer;
export const { setIsViewProjectDetails, setIsInvite } = projectSlice.actions;
